import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { InvoiceMatchPaymentsDataEffects } from './invoice-match-payments-data.effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './invoice-match-payments-data.reducer';
import { InvoiceMatchPaymentsDataDispatcher } from './invoice-match-payments-data.dispatcher';
import { InvoiceMatchPaymentsDataService } from './invoice-match-payments-data.service';
import { InvoiceMatchPaymentsDataStore } from './invoice-match-payments-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([InvoiceMatchPaymentsDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class InvoiceMatchPaymentsDataModule {
  static forRoot(): ModuleWithProviders<InvoiceMatchPaymentsDataModule> {
    return {
      ngModule: InvoiceMatchPaymentsDataModule,
      providers: [
        InvoiceMatchPaymentsDataDispatcher,
        InvoiceMatchPaymentsDataService,
        InvoiceMatchPaymentsDataStore,
      ],
    };
  }
}
